import { styled, css, MenuList } from '@mui/material';

import ButtonContainer from '../../../components/ButtonContainer';

export const StyledUserDropdown = styled('div')(
  ({ theme }) => css`
    display: none;

    ${theme.breakpoints.up('desktop')} {
      display: block;
    }
  `
);

export const StyledUserMenuList = styled(MenuList)`
  max-height: 22rem;
  overflow-y: scroll;
`;

export const StyledSignoutButtonContainer = styled(ButtonContainer)(
  ({ theme }) => css`
    margin-bottom: ${theme.spacing('1XL')};
  `
);
